import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class SharedService {

  private sharedData: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();

  constructor() { }

  private jobSiteShared = new BehaviorSubject<any>({
    id:0,
    CustomerId: 0,
    Title: '0',
  });



  setCustomerInfo(jobSiteShared: any) {
    this.jobSiteShared.next(jobSiteShared);
  }

  getCustomerInfo() {
    return this.jobSiteShared.asObservable();
  }



}